/** @jsx jsx */
import { css, jsx } from "@emotion/core"

import React from "react"
import { Button, IconButton, Layer, List, Spacer, TextGroupMedium } from "@cd2/components"
import { IComponentProp } from "@cd2/tools"
import { IComponentProps } from "@cd2/components/build/es6/types/utils"

interface IProps {
  onRequestClose: IComponentProp<typeof Layer, "onRequestClose">
  isOpen: IComponentProp<typeof Layer, "isOpen">
  heading: IComponentProp<typeof TextGroupMedium, "heading">
  subheading: IComponentProp<typeof TextGroupMedium, "body">
  actions?: IComponentProps<typeof Button>[]
  width?: "wide" | "normal" | number
  children?: React.ReactNode
  noCloseButton?: boolean
  noPadding?: boolean
}
export function Dialogue({
  children,
  onRequestClose,
  isOpen,
  heading,
  subheading,
  actions,
  width,
  noCloseButton,
}: IProps) {
  return (
    <Layer
      onRequestClose={onRequestClose}
      isOpen={isOpen}
      theme={{
        animation: "fade",
        layerWidth: typeof width === "number" ? width : width === "wide" ? 700 : 340,
        position: "center",
        layerColor: "white",
        layerPadding: 24,
        borderRadius: 2,
      }}
      css={css`
        max-height: 90vh !important;
        overflow: auto;
      `}
    >
      {heading && (
        <React.Fragment>
          <TextGroupMedium
            heading={heading}
            body={subheading}
            theme={{ body: { color: "#666" } }}
          />
          {children && <Spacer />}
        </React.Fragment>
      )}
      {children}

      {actions && (
        <React.Fragment>
          <Spacer size={24} />
          <List alignItems="end" horizontal>
            {actions.map((buttonProps, i) => (
              <Button key={i} {...buttonProps} />
            ))}
          </List>
        </React.Fragment>
      )}
      {onRequestClose && !noCloseButton && (
        <div
          css={css`
            position: absolute;
            top: 4px;
            right: 4px;
          `}
        >
          <IconButton
            icon="times"
            onClick={onRequestClose}
            padding={8}
            buttonStyle={"text"}
            square
          />
        </div>
      )}
    </Layer>
  )
}
